/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { rendererIconByName } from '@gh/common-internal-shared';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { SalesTaxRate } from '../../resources/estimating-sales-tax-rates-tab.model';

@Injectable()
export class EstimatingSalesTaxRateListTabGridDefinition extends LayoutBasedGridDefinition {
  columnDefs = {
    isDefault: {
      cellRenderer: (params: any): string => params.node.data.isDefault ? rendererIconByName('done') : '',
    },
  };

  options = {
    getRowNodeId: (data: SalesTaxRate) => data.id,
  };
}
